import { Controller } from '@hotwired/stimulus';
import TomSelect from 'tom-select';

// The policy associates picker: grouped options loaded once from the
// policy's own list endpoint.
export default class extends Controller {
  connect() {
    this.select = new TomSelect(this.element, {
      valueField: 'id',
      labelField: 'name',
      searchField: ['name'],
      create: false,
      highlight: true,
      optgroups: [
        { value: 'policy_groups', label: 'Policy Groups' },
        { value: 'customers', label: 'Customers' },
      ],
      load: (_query, callback) => this.load(callback),
      render: {
        option: (item, escape) =>
          `<div class="py-2 d-flex"><div class="mb-1"><span class="h5">${escape(
            item.name,
          )}</span></div></div>`,
      },
    });
  }

  disconnect() {
    if (this.select) this.select.destroy();
  }

  load(callback) {
    if (this.select.loading > 1) {
      callback();
      return;
    }

    const policyId = window.location.pathname.match(/policies\/(\d+)\//);
    if (!policyId) return callback();

    fetch(`/policies/${policyId[1]}/associates/list`)
      .then((response) => response.json())
      .then((json) => {
        callback(json);
        this.select.settings.load = null;
      })
      .catch(() => callback());
  }
}
